import * as service from './service'
export default {
  namespace: 'acceleratorCardCardDetail',
  state: {
    cardDetailData: {}
  },
  effects: {
    * getCardDetail ({ payload }, { call, put }) {
      const res = yield call(service.getCardDetail, payload)
      yield put({
        type: 'save',
        payload: {
          cardDetailData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
